//window.API_URL = "https://prodtest.envoke-demos.com/";
//window.API_URL = "https://localhost:44366/";
//window.API_URL = "http://127.0.0.1:8000/";
//window.APP_URL = "https://app.demo-face.com/";

window.API_URL = "https://api.envoke-demos.com/";
window.APP_URL = "https://app.envoke-demos.com/";